import React from 'react';
import { GetServerSidePropsResult, GetServerSidePropsContext } from 'next';
import PageContainer from 'components/global/PageContainer';
import FullPageFormWrapper from 'components/form-wizards/fullPageFormWrapper/FullPageFormWrapper';
import getLandingPageData from 'app-requests/content-type-loaders/landing-page-props';
import handleServerRedirect from 'utils/handleServerRedirect';
import { APIError } from 'utils/errors/APIError';
import { APITransformError } from 'utils/errors/APITransformError';
import { LogError } from 'utils/logging';
import {
  clickPortalRedirect,
  defaultRedirect,
  notFoundRedirect,
  serverMaintenanceRedirect,
  SITE_TYPE,
} from 'consts';
import { SiteTypeError } from 'utils/errors/SiteTypeError';
import { ServerSidePageProps } from 'types';

function LandingPageForm(props: {
  pageProps: ServerSidePageProps;
}): JSX.Element {
  const { pageProps } = props;

  return (
    <PageContainer pageProps={pageProps}>
      <FullPageFormWrapper />
    </PageContainer>
  );
}

export async function getServerSideProps(
  context: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<ServerSidePageProps | object>> {
  try {
    const pageProps = await getLandingPageData(context, false, true);
    pageProps.title = 'Full Page Form';
    return { props: pageProps };
  } catch (error: unknown) {
    if (
      error instanceof APIError &&
      error.statusCode === 404 &&
      context.req.url !== defaultRedirect
    ) {
      handleServerRedirect(defaultRedirect, context);
      return { props: {} };
    }

    if (error instanceof APIError && error.statusCode === 404) {
      handleServerRedirect(notFoundRedirect, context);
      return { props: {} };
    }

    if (
      error instanceof SiteTypeError &&
      error.siteType === SITE_TYPE.CLICK_PORTAL
    ) {
      handleServerRedirect(clickPortalRedirect, context);
      return { props: {} };
    }

    if (error instanceof APIError) {
      LogError(error, {
        statusCode: error.statusCode,
        endpoint: error.endpoint,
        route: 'landing/form',
      });
    } else if (error instanceof APITransformError) {
      LogError(error, {
        method: error.method,
        route: 'landing/form',
      });
    } else {
      LogError(error as Error, {
        route: 'landing/form',
      });
    }

    if (process.env.NODE_ENV === 'development') {
      throw error;
    } else {
      handleServerRedirect(serverMaintenanceRedirect, context, 302);
    }
    return { props: {} };
  }
}

export default LandingPageForm;
